import React from "react";
import { FaInfoCircle } from "react-icons/fa"; // Info icon
import { MdClose } from "react-icons/md"; // Close icon
import styles from "./css/Info.module.css";

const FvgInfo = ({ isOpen, toggleDrawer }) => {
  return (
    <div>
      {/* Collapsible Side Drawer */}
      <div className={`${styles.drawer} ${isOpen ? styles.open : ""}`}>
        <div className={styles.drawerHeader}>
          <MdClose className={styles.closeIcon} onClick={toggleDrawer} />
        </div>

        <div className={styles.infoItem}>
          <h4>What is an FVG?</h4>
          <p>
            A Fair Value Gap (FVG) is a significant price imbalance on a chart, formed when there’s a gap between the low
            of one candle and the high of another. This gap occurs due to a rapid market movement, often reflecting
            strong buying or selling pressure. 
          </p>
          <p>
            <b>Why is it important to traders?</b> Traders view FVGs as potential areas of retracement or reversal,
            where price is likely to revisit and "fill the gap" to establish a fair value. These gaps often signal
            opportunities for:
          </p>
          <ul>
            <li>Identifying entry and exit points.</li>
            <li>Analyzing market momentum and strength.</li>
            <li>Spotting potential retracement or continuation patterns.</li>
          </ul>
        </div>

        <div className={styles.infoItem}>
          <h4>1. Gap Formation</h4>
          <p>
            <b>Definition:</b> A Bearish FVG forms when the low of the previous candle is greater than the high of the
            next candle.<br />
            <b>Usage:</b> The gap is identified and marked for potential retracement opportunities.
          </p>
        </div>

        <div className={styles.infoItem}>
          <h4>2. Upper Bound</h4>
          <p>
            <b>Definition:</b> The low price of the previous candle that starts the gap.<br />
            <b>Usage:</b> Marked by a <span className={styles.red}>red horizontal line</span> on the chart.
          </p>
        </div>

        <div className={styles.infoItem}>
          <h4>3. Lower Bound</h4>
          <p>
            <b>Definition:</b> The high price of the next candle that ends the gap.<br />
            <b>Usage:</b> Marked by a <span className={styles.yellow}>yellow horizontal line</span> on the chart.
          </p>
        </div>

        <div className={styles.infoItem}>
          <h4>4. Retracement Detection</h4>
          <p>
            <b>Definition:</b> A price movement that re-enters the gap, indicating a potential retracement.<br />
            <b>Usage:</b> Marked dynamically as price action evolves.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FvgInfo;
